import React from 'react';
import './headerStyles.css'
// props :{
//     players : string[],
//     scores: Number[], 
//     gameName: string
// }
export const Header = (props) =>{
    const isSelected = props.scores[0] > props.scores[1] ? 0 : 1; 
    return (
        <div className="header-container">
           <p className="game-name"> {props.gameName} </p>
           {props.players.map((key, index)=>{
               if (isSelected==index) {
                   return (<p className="selected-player"> {key} {props.scores[index]} points</p>)
               }
               return (<p> {key} {props.scores[index]} points</p>)
           })}
        </div>
    )
}